import { EPackageType, TAppState } from '../../types';
import { selectBuyPackageModalData } from './selectBuyPackageModalData';

export const selectPackageType = (state: TAppState): EPackageType | undefined => {
  const { type } = selectBuyPackageModalData(state);

  return type;
};
